import { render, staticRenderFns } from "./ChangeEditingModeButton.vue?vue&type=template&id=30efd7f9&scoped=true&"
import script from "./ChangeEditingModeButton.vue?vue&type=script&lang=ts&"
export * from "./ChangeEditingModeButton.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeEditingModeButton.vue?vue&type=style&index=0&id=30efd7f9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30efd7f9",
  null
  
)

export default component.exports